module.exports = __webpack_public_path__ + "static/media/blue-arrow-down.3cc6a064.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/blue-arrow-down.svg
// module id = 850
// module chunks = 21